<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.packInfo" mode="text" status="primary"/>
      </div>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(item)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="list"
        :export-config="{}"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        keep-source
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="150"/>
        <vxe-column field="item.name" title="business.label.itemName" width="300"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:dataSources}" field="dataSource" title="business.label.dataSource" width="80"/>
        <vxe-column field="specification" title="business.label.specification" width="200"/>
        <vxe-column field="uom" title="business.label.uom" width="60"/>
        <vxe-column field="factor" title="business.label.factor" width="60"/>
        <vxe-column field="innerFactor" title="business.label.innerFactor" width="60"/>
        <vxe-column field="dimension.length" title="business.label.length" width="100"/>
        <vxe-column field="dimension.width" title="business.label.width" width="100"/>
        <vxe-column field="dimension.height" title="business.label.height" width="100"/>
        <vxe-column field="dimension.volume" title="business.label.volume" width="100"/>
        <vxe-column field="weight" title="business.label.weight" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <pack-editor ref="editor" :data-sources="dataSources" :shapes="shapes" @success="refresh(item)"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import PackEditor from '@/views/basedata/item/PackEditor.vue'

export default {
  name: 'PackTable',
  components: { PackEditor },
  data() {
    return {
      loading: false,
      item: new Item(),
      list: []
    }
  },
  props: {
    dataSources: {
      type: Array,
      default: []
    },
    shapes: {
      type: Array,
      default: []
    }
  },
  methods: {
    refresh(item) {
      this.item = item
      if (this.item.isNew()) {
        return this.$message.warning('请先选择商品')
      }
      this.loading = true
      findAll('packFactory', { 'item.id': this.item.id }).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.item)
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    }
  }
}
</script>